import { useState } from 'react'
import { getAllApps, getAllBoards, getAllProjects, getPinnedProjectIds, getTopApps, getTopBoards } from '@/data/adapters/navigationData'

export function useSecondaryNavSectionCtx(props) {
  const [searchValue, setSearchValue] = useState('')
  const [selectedProjectId, setSelectedProjectId] = useState(null)
  return {
    index: 0,
    activeKey: props.activeKey,
    searchValue,
    setSearchValue,
    topBoards: getTopBoards(5),
    allBoards: getAllBoards(),
    topApps: getTopApps(5),
    allApps: getAllApps(),
    ...props,
    projects: props.projects ?? getAllProjects(),
    pinnedProjectIds: props.pinnedProjectIds ?? getPinnedProjectIds(),
    selectedProjectId: props.selectedProjectId ?? selectedProjectId,
    onProjectSelect:
      props.onProjectSelect ??
      ((project) => {
        setSelectedProjectId(project?.id ?? null)
      }),
    onNewProject: () => {
      setSelectedProjectId(null)
      ;(props.onNewProject ?? props.onBuild)?.()
    },
  }
}
